import { useSelector } from 'react-redux';

import {
    ModulesApiRoutes,
    ModulesIntents,
    ModulesRoutes,
    ModulesSettings,
} from '../drivers';

const FALLBACK_MODULE = 'gd';

const useMailerDriver = () => {
    const activeModule = useSelector((state) => state.Modules.active);
    const active = ModulesApiRoutes[activeModule] ? activeModule : FALLBACK_MODULE;

    return {
        active,
        apiRoutes: ModulesApiRoutes[active],
        intents: ModulesIntents[active],
        routes: ModulesRoutes[active],
        settings: ModulesSettings[active],
    };
};

export default useMailerDriver;
